MultiStepForm[3] = {
  birth_date: false,
  nationality: false,
  gender: false,
  marital_status: false,
  phone_plan: false,
  dependant_count: false,
}

let birthdate_value = ""

const getAge = (value) => {
  const today = new Date()
  const birthDate = new Date(value)

  const birthDateStr =
    birthDate.getFullYear() +
    "-" +
    ("0" + (birthDate.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + birthDate.getDate()).slice(-2)

  if (value != birthDateStr) {
    return 0
  }

  let age = today.getFullYear() - birthDate.getFullYear()
  const m = today.getMonth() - birthDate.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--
  }
  return age
}

const validateBirthDate = () => {
  const day = document.getElementById("birth_date-day").value
  const month = document.getElementById("birth_date-month").value
  const year = document.getElementById("birth_date-year").value

  const value = year + "-" + month + "-" + day
  if (value !== "" && value.length == 10) {
    birthdate_value = day + "-" + month + "-" + year

    const age = getAge(value)
    return age >= 18 && age <= 80
  }

  return false
}

jQuery(document).ready(function ($) {
  // Gender
  const $genderRadioButtons = $('#LeadForm-gender input[type="radio"]')
  $("body").on("click", $genderRadioButtons, function (event) {
    const $this = $(event.target).children()

    if ($this.prop("type") == "radio" && ["FEMALE", "MALE"].includes($this.prop("id"))) {
      if ($this.prop("id") == "MALE") {
        $("#LeadForm-gender label.btn-default.MALE").addClass("active")
        $("#LeadForm-gender label.btn-default.FEMALE").removeClass("active")
      } else {
        $("#LeadForm-gender label.btn-default.MALE").removeClass("active")
        $("#LeadForm-gender label.btn-default.FEMALE").addClass("active")
      }

      showSuccess(3, "gender")
      $("#form-toggle-gender").val($this.prop("id"))

    }
  })

  $("body").on("change", "#form-toggle-step-3 #LeadForm-gender", function () {
    const name = $(this).data("name")
    const field = $(this).data("label").toLowerCase()

    const button = $(`#LeadForm-${name} label.btn-default`)
    if (button.hasClass("active")) {
      showSuccess(3, name)
    } else {
      const message = `Por favor, selecciona tu ${field}.`
      showError(3, name, field, "", message)
    }
  }) //end of gender event

  // Phone plan event
  const $phonePlanRadioButtons = $('#LeadForm-phone_plan input[type="radio"]')
  $("body").on("click", $phonePlanRadioButtons, function (event) {
    const $this = $(event.target).children()

    if ($this.prop("type") == "radio" && ["CONTRACT", "PREPAID"].includes($this.prop("id"))) {
      if ($this.prop("id") == "CONTRACT") {
        $("#LeadForm-phone_plan label.btn-default.CONTRACT").addClass("active")
        $("#LeadForm-phone_plan label.btn-default.PREPAID").removeClass("active")
      } else {
        $("#LeadForm-phone_plan label.btn-default.CONTRACT").removeClass("active")
        $("#LeadForm-phone_plan label.btn-default.PREPAID").addClass("active")
      }

      showSuccess(3, "phone_plan")
      $("#form-toggle-phone_plan").val($this.prop("id"))
      
    }
  })

  $("body").on("change", "#form-toggle-step-3 #LeadForm-phone_plan", function () {
    const name = $(this).data("name")
    const field = $(this).data("label").toLowerCase()

    const button = $(`#LeadForm-${name} label.btn-default`)
    if (button.hasClass("active")) {
      showSuccess(3, name)
    } else {
      const message = `Por favor, selecciona tu ${field}.`
      showError(3, name, field, "", message)
    }
  }) //end of phone plan event

  $("body").on("change", "#form-date-step-3 select", function (event) {
    const name = $(event.target).data("name")
    if (validateBirthDate()) {
      $(`#LeadForm-${name}`).val(birthdate_value)
      showSuccess(3, name)
    } else {
      const message = "Por favor, ingresa una fecha de nacimiento válida."
      showError(3, name, "", "", message)
    }
  })

  $("body").on("change", "#form-selector-step-3 select", function () {
    const value = $(this).val()
    const name = $(this).data("name")
    const field = $(this).data("label").replace(/-/g, " ").toLowerCase()

    if (value) {
      showSuccess(3, name)
    } else {
      const message = `Por favor, selecciona tu ${field}.`
      showError(3, name, field, value, message)
    }
  })

  $("body").on("click", "#submit-button-step-3", function (event) {
    event.preventDefault()
    submitForm(3)
  })

  $("body").on("click", "#previous-button-step-3", function (event) {
    event.preventDefault()
    showPreviousForm(2)
  })

  $("body").on("click", "#mobile-previous-button-step-3", function (event) {
    event.preventDefault()
    showPreviousForm(2)
  })

  $("body").on("click", "#sidebar-step-2", function (event) {
    event.preventDefault()
    showPreviousForm(2, "sidebar")
  })
})
